<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table :headers="headers" :items="semester_list" dense class="elevation-1 mytable" :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Semester</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="1" cols="12"> </v-col>
                        <v-col sm="6" md="4" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Semester</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.semester_name"
                                                        :disabled="editedIndex != -1" persistent-hint :hint="
                                                          editedIndex == -1
                                                            ? 'For example :: I, II...'
                                                            : 'noneditable'
                                                        " label="Enter Semester" :rules="[(v) => !!v || 'required']">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.semester_display_name"
                                                        label="Display Name" hint="I, II..."
                                                        :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.semester_unicode_display_name"
                                                        label="Unicode Display Name"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <!-- from date -->
                                                <p><v-icon color="error">*</v-icon><b> From Date</b></p>
                                                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                                    transition="scale-transition" offset-y max-width="290px"
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field dense outlined rounded v-model="new_from_date"
                                                            @blur="date1 = parseDate(new_from_date)" v-on="on"
                                                            prepend-icon="event" persistent-hint
                                                            label="From Date"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="date1" no-title
                                                        @input="menu1 = false"></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <p><v-icon color="error">*</v-icon><b> From Date</b></p>
                                                <!-- <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field dense outlined rounded v-model="new_from_date_edit" @blur="date3 = parseDate(new_from_date_edit)" v-on="on" prepend-icon="event" persistent-hint label="From Date"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="date3" no-title @input="menu3 = false"></v-date-picker>
                                                </v-menu> -->
                                                <v-menu v-model="menu3" :close-on-content-click="false"
                                                    :nudge-right="40" transition="scale-transition" offset-y
                                                    min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field hint="YYYY/MM/DD format" persistent-hint
                                                            v-model="new_from_date_edit" label="Edit From Date"
                                                            prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                            v-on="on"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="new_from_date_edit"
                                                        @input="menu3 = false"></v-date-picker>
                                                </v-menu>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <!-- to date -->
                                                <p><v-icon color="error">*</v-icon><b> To Date</b></p>
                                                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                                                    transition="scale-transition" offset-y max-width="290px"
                                                    min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field dense outlined rounded v-model="new_to_date"
                                                            @blur="date2 = parseDate(new_to_date)" v-on="on"
                                                            prepend-icon="event" persistent-hint
                                                            label="To Date"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="date2" no-title
                                                        @input="menu2 = false"></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <p><v-icon color="error">*</v-icon><b> To Date</b></p>
                                                <!-- <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field dense outlined rounded v-model="new_to_date_edit" @blur="date4 = parseDate(new_to_date_edit)" v-on="on" prepend-icon="event" persistent-hint label="To Date"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="date4" no-title @input="menu4 = false"></v-date-picker>
                                                </v-menu> -->
                                                <v-menu v-model="menu4" :close-on-content-click="false"
                                                    :nudge-right="40" transition="scale-transition" offset-y
                                                    min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field hint="YYYY/MM/DD format" persistent-hint
                                                            v-model="new_to_date_edit" label="Edit From Date"
                                                            prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                            v-on="on"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="new_to_date_edit"
                                                        @input="menu4 = false"></v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive_for_examination"
                                                        color="success" label="Active For Examination?"></v-checkbox>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Is Active?"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive_for_examination="{ item }">
                    <span v-if="item.isactive_for_examination">
                        <v-icon class="mr-2 v-icon-size" color="success"
                            title="Active">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error"
                            title="Not Active">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success"
                            title="Active">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error"
                            title="Not Active">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>

            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            valid: false,
            // extraBreadcrumbItems: [
            //     { text: "Semester Master", disabled: true, href: "" },

            // ],


            // breadcrumbClass: "breadcrumb-style2",
            overlay: false,
            errorMsg: {
                id: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            headers: [
                {
                    text: "Semester",
                    align: "left",
                    sortable: false,
                    value: "semester_name",
                },
                {
                    text: "Display Name",
                    align: "left",
                    sortable: false,
                    value: "semester_display_name",
                },
                 {
                    text: "Unicode Display Name",
                    align: "left",
                    sortable: false,
                    value: "semester_unicode_display_name",
                },
                {
                    text: "Start Date",
                    align: "left",
                    sortable: false,
                    value: "from_date",
                },
                {
                    text: "End Date",
                    align: "left",
                    sortable: false,
                    value: "to_date",
                },
                {
                    text: "Is Active For Examination",
                    align: "left",
                    sortable: false,
                    value: "isactive_for_examination",
                },
                {
                    text: "Is Active",
                    align: "left",
                    sortable: false,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            date1: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            date3: new Date().toISOString().substr(0, 10),
            date4: new Date().toISOString().substr(0, 10),
            menu1: false,
            menu2: false,
            menu3: false,
            menu4:false,
            semester_list: [],
            editedIndex: -1,
            new_from_date: "",
            new_to_date: "",
            new_from_date_edit: "",
            new_to_date_edit: "",
            editedItem: {
                id: "",
                semester_name: "",
                isactive_for_examination:false,
                isactive:false,
            },
            defaultItem: {
                id: "",
                semester_name: "",
                isactive_for_examination:false,
                isactive:false,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Semester" : "Edit Semester";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
            date1(val) {
                this.new_from_date = this.formatDate(this.date1);
            },
            date2(val) {
                this.new_to_date = this.formatDate(this.date2);
            },
        },

        mounted() {
            this.onLoad();
        },
        methods: {
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            initializeErrorMsgFalse() {
                this.errorMsg.semester_name = false;
            },

            onLoad() {
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/semesterMasterHome")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if ((this.load = true)) {
                                this.overlay = false;
                                this.semester_list = res.data.semester_list;
                            }
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        var overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            editItem(item) {
                this.editedIndex = this.semester_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.new_from_date_edit = this.editedItem.from_date_edit,
                this.new_to_date_edit = this.editedItem.to_date_edit
                this.dialog = true;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
                this.new_from_date =""
                this.new_to_date =""
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                      const data = {
                        from_date_edit : this.new_from_date_edit,
                        to_date_edit : this.new_to_date_edit,
                        isactive_for_examination :this.isactive_for_examination,
                        editedItem:this.editedItem
                      }
                        axios
                            .post("/AdmissionMaster/editSemesterMaster", data)
                            .then((res) => {
                                if (res.data.status == "YES") {
                                  //  Object.assign(this.semester_list[this.editedIndex], this.editedItem);
                                    this.onLoad();
                                    this.showSnackbar("#4caf50", "Semester Updated Successfully..."); // show snackbar on success
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", "Semester Already Present!!!"); // show snackbar on error
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                } else {
                  const data = {
                    editedItem: this.editedItem,
                     from_date: this.new_from_date,
                    to_date: this.new_to_date,
                     isactive_for_examination :this.isactive_for_examination,
                  }
                    axios
                        .post("/AdmissionMaster/saveSemesterMaster", data)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.semester_list.push(this.editedItem);
                                this.onLoad();
                                this.showSnackbar("#4caf50", "Semester Added Successfully..."); // show snackbar on success
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Semester Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.semester_name) {
                    return true;
                } else {
                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
